import { render, staticRenderFns } from "./supply-chain-category.vue?vue&type=template&id=d514cc36&scoped=true"
import script from "./supply-chain-category.vue?vue&type=script&lang=ts"
export * from "./supply-chain-category.vue?vue&type=script&lang=ts"
import style0 from "./supply-chain-category.vue?vue&type=style&index=0&id=d514cc36&prod&scoped=true&lang=scss"
import style1 from "./supply-chain-category.vue?vue&type=style&index=1&id=d514cc36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d514cc36",
  null
  
)

export default component.exports